var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mod-tit-wrap"},[_c('i',{staticClass:"arrow",class:[_vm.icon ? _vm.icon : '']}),_c('div',{class:['bg', _vm.type]},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }